<template>

  <div class="vorvers bg-dimmed round-corners">
    <v-icon v-if="remove"
            class="delete-vv"
            @click="$emit('vvdelete')">close
    </v-icon>

    <v-row no-gutters>

      <v-col cols="12"
             sm="3">
        <div class="mylabel">
          Vorversicherung {{ index + 1 }}
        </div>
      </v-col>

      <v-col id="content"
             cols="12"
             sm="9">

          <v-row no-gutters>

            <v-col cols="12"
                   md="6">
              <v-text-field v-model="vorversicherer"
                            v-validate="'required'"
                            :error-messages="errors.collect('vorversicherer')"
                            data-vv-as="Vorversicherer"
                            class="required"
                            name="vorversicherer"
                            label="Vorversicherer" />
            </v-col>

            <v-col cols="12"
                   md="6">
              <v-text-field v-model="vscheinnr"
                            v-validate="'required'"
                            :error-messages="errors.collect('vscheinnr')"
                            data-vv-as="Versicherungsschein-Nr."
                            class="required"
                            name="vscheinnr"
                            label="Versicherungsschein-Nr." />
            </v-col>
          </v-row>

          <v-row no-gutters
                 class="rb-line">

            <v-col cols="4"
                   md="3">
              <label class="dmb-form-text">gekündigt durch*</label>
            </v-col>

            <v-col cols="8"
                   md="9">
              <v-radio-group v-model="von"
                             v-validate="'required'"
                             :error-messages="errors.collect('von')"
                             data-vv-as="gekündigt durch"
                             data-vv-name="von"
                             name="von"
                             class="ma-0 pa-0">
                <v-row no-gutters>
                  <v-col cols="12"
                         md="6">
                    <v-radio label="Versicherungsnehmer"
                             value="VN"
                             color="primary" />
                  </v-col>
                  <v-col :class="$vuetify.breakpoint.mdAndUp ? 'ma-0' : ''"
                         cols="12"
                         md="6">
                    <v-radio label="Versicherung"
                             value="VR"
                             color="primary" />
                  </v-col>
                </v-row>
              </v-radio-group>

            </v-col>

          </v-row>

          <v-row no-gutters>
            <v-col cols="12"
                   md="6">
              <date-field v-model="zum"
                          v-validate="'required|date_format:DD.MM.YYYY'"
                          :error-messages="errors.collect('zum')"
                          data-vv-as="Kündigungsdatum"
                          class="required"
                          hint="tt.mm.jjjj"
                          name="zum"
                          label="gekündigt zum" />
            </v-col>

          </v-row>
      </v-col>

    </v-row>

  </div>
</template>

<script>
import KeyTranslator from "@/components/helper/keyTranslatorMixin";
import ValidationMixin from "@/components/helper/ValidationMixin";
import {mapTwoWay} from "@/store/twowayBindingMixin";
import twowayBinding from "@/store/twowayBindingMixin";
import DateField from "@/components/DateField";

export default {
  components: { DateField },
  mixins: [ValidationMixin, KeyTranslator, twowayBinding],
  props: {
    index: {
      type: Number,
      required: true
    },
    remove: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapTwoWay(["vscheinnr", "zum", "von", "vorversicherer"])
  }
};
</script>

<style>
.vorvers {
  padding-top: 16px;
  position: relative;
}

.vorvers .v-icon {
  color: rgba(0, 0, 0, .87);
}

.vorvers #content {
  padding: 0 0 0 16px;
}

.vorvers .v-input {
  padding-right: 16px;
}

.vorvers .v-input-group.v-radio {
  margin: 0 !important;
}

.vorvers .mylabel {
  padding-left: 16px;
  color: #002C76;
  text-align: left;
  font-size: 16px;
}

.vorvers .delete-vv {
  position: absolute;
  top: 8px;
  right: 8px;
}

.vorvers .dmb-form-text {
  font-size: 16px;
  color: rgba(0, 0, 0, .87);
}

.vorvers .rb-line {
  /*simulating input text line*/
  padding-top: 16px;
  margin-bottom: 18px;
}

.vorvers .v-input.v-input--selection-controls label {
  overflow: visible !important;
}

.vorvers .v-radio:first-child {
  min-width: 250px;
}

</style>

